import { render, staticRenderFns } from "./histogram-transposed.vue?vue&type=template&id=fe02cef0&"
import script from "./histogram-transposed.vue?vue&type=script&lang=js&"
export * from "./histogram-transposed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports